export const getTrackingUrl = (username) => {
  if (!username) return "#";

  return `https://t.me/LightDealerBot?start=r_outlightfun-channel-${username}`;
};
